// AutoMapper
import { AutoMap } from '@nartc/automapper';

// Dto
import { InsureeDto } from 'app/_mapper/insuree.dto';
import { PolicyDto } from 'app/_mapper/policy.dto';
import { CaseDetailDto } from 'app/_mapper/casedetail.dto';
import { LocationDto } from 'app/_mapper/location.dto';
import { PartyDto } from 'app/_mapper/party.dto';
import { TravelDto } from 'app/_mapper/travel.dto';
import { HelpPlanDto } from 'app/_mapper/helpplan.dto';

export class DossierDto {
    @AutoMap() dossierId: string;
    @AutoMap() creationDate: string;
    @AutoMap() dossierNumber: string;
    @AutoMap() draftDossierNumber: string;
    @AutoMap() intakeDuration: number;
    @AutoMap() comments: string;
    @AutoMap() agreements: string;
    @AutoMap() isUrgent: boolean;
    @AutoMap(() => InsureeDto) insuree: InsureeDto;
    @AutoMap(() => PolicyDto) policy = new PolicyDto();
    @AutoMap(() => CaseDetailDto) caseDetail: CaseDetailDto;
    @AutoMap(() => LocationDto) locations: LocationDto[];
    @AutoMap(() => TravelDto) travel: TravelDto;
    @AutoMap(() => PartyDto) parties: PartyDto[];
    @AutoMap(() => HelpPlanDto) helpPlans: HelpPlanDto[];
    @AutoMap(() => DossierDto) linkedDossiers: DossierDto[];
}